module.exports = __webpack_public_path__ + "img/special_cal_scene.79f46b66.png";